export const baseUrl = process.env.REACT_APP_BASE_URL;
export const metriwsBaseUrl = process.env.REACT_APP_METRIWS_BASE_URL;
export const baseUrlImg = `${process.env.REACT_APP_BASE_URL}assets/icon/`;
